import {FC} from 'react'
import {Table} from 'react-bootstrap'
import {CGEShock, CGEMetadata} from '../core/_models'

type CGEShocksAppliedTableProps = {
  shocks: CGEShock[]
  metadata: CGEMetadata | null
}

const CGEShocksAppliedTable: FC<CGEShocksAppliedTableProps> = ({shocks, metadata}) => {
  const sectorName = (code: string) => metadata?.sectors.find((s) => s.code === code)?.name ?? code
  const regionName = (code: string) => metadata?.regions.find((r) => r.code === code)?.name ?? code

  return (
    <div className='cge-scroll-table'>
      <Table size='sm' className='align-middle mb-0' striped bordered hover>
        <thead>
          <tr>
            <th>Sector</th>
            <th>Exporting region</th>
            <th>Importing region</th>
            <th className='text-end'>Tariff (tms) power change %</th>
          </tr>
        </thead>
        <tbody>
          {shocks.map((s, i) => (
            <tr key={i}>
              <td>{sectorName(s.good)}</td>
              <td>{regionName(s.source)}</td>
              <td>{regionName(s.dest)}</td>
              <td className='text-end'>
                <span
                  className={
                    s.tms_power_change_pct >= 0 ? 'text-success fw-bolder' : 'text-danger fw-bolder'
                  }
                >
                  {s.tms_power_change_pct >= 0 ? '+' : ''}
                  {s.tms_power_change_pct}%
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  )
}

export {CGEShocksAppliedTable}
